<script>
	export let recommendation
</script>

<div class="recommendation" >
	<div class="title">
		<h3>{recommendation.title}</h3>
		<div class="rating">
			<svg class="star" xmlns="http://www.w3.org/2000/svg" version="1.2" baseProfile="tiny-ps" viewBox="0 0 60 58" width="60" height="58">
				<g id="Layer">
					<path id="Layer" class="shp0" d="M45.5 57.5C44.7 57.5 44 57.3 43.3 56.9L34.1 52.1C32.9 51.4 31.5 51.1 30 51.1C28.5 51.1 27.2 51.4 25.9 52.1L16.7 56.9C16 57.3 15.3 57.5 14.5 57.5C13.1 57.5 11.8 56.9 10.9 55.8C10 54.7 9.6 53.4 9.9 52L11.7 41.7C12.2 38.9 11.2 36 9.2 34L1.7 26.7C0.4 25.4 -0.1 23.6 0.5 21.9C1.1 20.2 2.5 19 4.3 18.7L14.6 17.2C17.4 16.8 19.9 15 21.2 12.4L25.8 3.1C26.6 1.5 28.2 0.5 30 0.5C31.8 0.5 33.4 1.5 34.2 3.1L38.8 12.4C40.1 15 42.5 16.8 45.4 17.2L55.7 18.7C57.5 19 58.9 20.2 59.5 21.9C60.1 23.6 59.6 25.4 58.3 26.7L50.8 34C48.7 36 47.8 38.9 48.3 41.7L50.1 52C50.3 53.4 50 54.7 49.1 55.8C48.2 56.9 46.8 57.5 45.5 57.5Z"/>
				</g>
			</svg>

			<span>{Math.round(recommendation.vote_average * 10) / 10}</span>

		</div>
	</div>

	<img class="cover" src="https://image.tmdb.org/t/p/w342{recommendation.poster_path}" alt="">
	<p class="overview">{recommendation.overview}</p>
</div>

<style>
	.recommendation {
		padding: 1rem;
		background-position: center center; 
	  background-repeat: no-repeat;
	  background-size: cover; 
	  max-width: 45ch;

	  background-color: #222;

	  border-radius: 0.5rem;
	  margin-bottom: 1rem;
	  display: inline-block;
	}
	.overview {
		
	}

	.cover {
		width: 100%;
		border-radius: 0.5rem;
		margin: 1rem 0;
		box-shadow: 0 0 transparent,0 0 transparent,0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05);
	}


	.title {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
	}

	.rating {
		display: flex;

	}

	.star {
		fill:  rgb(251, 191, 36);
		height: 1rem;
		width: 1rem;
		margin-right: 0.2rem;
	}

</style>